import axios from 'axios';
import qs from 'qs';
import cookie from '../cookieHelper/cookie'; 

export default function repostStory(storyId, createdBy) {
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);


    let data = {
        "parentId": storyId,
        "createdBy": createdBy,
    };

    const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/storyRepost`;

    return (
        axios.post(API_URL, qs.stringify(data), {
            headers: {
                Authorization: `Bearer ${authToken}`,
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        })
        .then(res => {
            // console.log('res repost: ', res);
            return res;
        })
        .catch(err => {
            // console.error('err repost: ', err);
            return err;
        })
    );
}
